<div class="delivery-open-engagements-view-part">
	<common-engagement-grid [pageService]="pageService" [data]="engagements()"></common-engagement-grid>
</div>